module.exports = __webpack_public_path__ + "static/dominikawork5-d9f12d0acc658b176db86d2fa0c56f8f.jpg";